import { createClient } from 'contentful';

export default createClient({
  space: 'wsdpdlh22n05',
  accessToken: 'Hl--Iic5VF4gxBJszeUARtSgvshNvMBFdzhqJRFDWic',
});
